import styled from "styled-components";

export const MenuContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  padding: 8px;

  h1 {
    margin-bottom: var(--margin-xl);
    text-transform: uppercase;
  }

  div.menu-item {
    width: 50%;
    max-width: 600px;
    text-align: center;
    background-color: var(--color-purple);
    color: #fff;
    padding: 8px;
    margin-bottom: 8px;
    cursor: pointer;

    h2 {
      font-size: 1em;
    }
  }

  @media screen and (min-width: 768px) {
    padding: 16px;

    div.menu-item {
      padding: 16px;  

      h2 {
        font-size: 1.4em;
      }
    }
  }
`;

export const BannerContainer = styled.div`
  display: block;
  height: 50vh;
  width: 100%;
  @media (max-width: 768px) {
    background-image: ${props => props.mobileUrl ? `url('${props.mobileUrl}')` : 'none'};
  }

  @media (min-width: 769px) {
    background-image: ${props => props.desktopUrl ? `url('${props.desktopUrl}')` : 'none'};
  }
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

export const StoreQuestionsContainer = styled.form`
  width: 100%;
  padding: 8px;
  background-color: #fff;
  color: #000;

  display: flex;
  flex-direction: column;

  h1 {
    text-align: center;
    margin: 16px 0 32px;
  }

  h2 {
    text-align: center;
    font-size: 1em;
    font-weight: 400;
    margin-bottom: 8px;
    text-transform: uppercase;
  }

  @media screen and (min-width: 768px) {
    width: 80%;
    margin: 32px auto 0;
    padding: 32px;

    h1 {
      margin: 0 0 32px 0;
    }
  }

  @media screen and (min-width: 1024px) {
    width: 70%;
  }

  @media screen and (min-width: 1200px) {
    width: 60%;
  }

  @media screen and (min-width: 1400px) {
    width: 50%;
  }
`;

export const QuestionItemContainer = styled.div`
  width: 100%;
  // max-width: 600px;
  margin: 0 auto 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: whitesmoke;
  padding: 16px 16px 8px;
  margin-bottom: 8px;

  h4 {
    margin-bottom: 16px;
  }

  h5 {
    margin-top: 16px;
    margin-bottom: 8px;
  }

  input[type="file"] {
    margin-top: 16px;
  }
`;

export const ActionContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  padding-top: 16px;
`;

export const CommentsContainer = styled.div`
  display: flex;
  flex-direction: column;

  textarea {
    padding: 8px;
    margin-bottom: 8px;
    resize: none;
  }
`;

export const FileItemContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  h6 {
    display: inline-block;
    font-size: 1.6rem;
    font-weight: 500;
  }

  span {
    font-size: 1.4rem;
    cursor: pointer;
  }
`;
